<template>
<article>
  <a :href="product.url">
    <div class="mx-4 bg-white">
      <div class="w-full relative" style="min-height:200px;">
        <div class="w-full placeholder absolute" style="z-index:-1;margin-bottom:100%;">
          <div class=" h-48 bg-gray-200">

          </div>
        </div>
        <span v-if="product.inStock" class="text-xs border py-1 px-2 rounded text-white font-bold bg-green-500 mt-4 inline-block">{{ messaging.inStock }}</span>
        <span v-else-if="product.onPurchaseOrder" class=" text-xs border py-1 px-2 rounded text-white font-bold bg-gray-500 mt-4 inline-block">{{ messaging.onPurchaseOrder }}</span>
        <span v-else-if="product.availableAtSupplier" class="text-xs border py-1 px-2 rounded text-white font-bold bg-gray-500 mt-4 inline-block">{{ messaging.availableAtSupplier }}</span>
        <span v-else class=" text-xs border py-1 px-2 rounded text-white font-bold bg-gray-500 mt-4 inline-block">{{ messaging.outOfStock }}</span>
        <img v-if="product.image" class="relative imgix" :src="product.image.url">
        <img v-else src="https://s3.ap-southeast-2.amazonaws.com/barratts/products/Group-165@2x.jpg" alt="">
      </div>
      <div class="flex flex-col justify-between items-center py-4">
        <div class="flex flex-col items-center justify-start">
            <div class="flex self-stretch justify-between text-xs mb-4">
                <div class="font-bold nowrap">{{product.publisherBrand}}</div>
                <div class="nowrap text-right">{{product.supplierID}}</div>
            </div>

          <p class="mb- text-center">
            {{ product.title }}
          </p>
        </div>
        <div :id="'product-' + product.id + '-purchasable-' + product.purchasable.id" class="purchasableInfo mt-0 text-center">
          <div class="flex items-center justify-center">
            <p class="pt-1 text-gray-900 text-xs font-medium mr-1 mb-0 uppercase" v-if="product.specialPrice">{{ product.textBeforePrice }}</p><p class="pt-1 text-gray-900 text-sm font-bold mb-0" :class="{'line-through': product.defaultVariant.onSale || product.specialPrice }">{{ product.purchasable.price | price }}</p>
          </div>
          <p class="pt-1 text-red-900 font-bold mb-0" v-if="product.defaultVariant.onSale">{{ product.purchasable.salePrice | price }}</p>
          <p class="pt-1 text-red-900 font-bold mb-0" v-else-if="product.specialPrice">{{ product.specialPrice | price }}</p>
          <strong v-if="product.purchasable.sales.length">Sales Applied:</strong>
          <strong class="text-xs uppercase text-red-900 " v-if="product.specialPrice">{{ product.specialPriceText }}</strong>
          <br>
          <ul>
            <li v-for="sale in product.purchasable.sales"><strong>{{ sale.name }}</strong> {{ sale.description }}</li>
          </ul>

        </div>
      </div>

      <!-- <div class="relative add-to-cart" v-if="product.variants.length > 1">
        <button class="bg-white block py-2 border border-gray-700 hover:bg-gray-800 text-center text-gray-700 hover:text-white w-full rounded-none mt-0 leading-normal add-to-cart__toggle" :id="'add-to-cart-' + product.defaultVariant.id"
          @click.prevent="openVariants('add-to-cart-' + product.defaultVariant.id)">Add to cart</button>
        <div class="absolute left-0 w-full h-0 overflow-hidden add-to-cart__variants">
          <form method="POST" class="mt-0" v-for="variant in product.variants">
            <input type="hidden" name="action" value="commerce/cart/update-cart">
            <input type="hidden" name="qty" value="1">
            <input type="hidden" :name="csrfName" :value="csrfToken">
            <input type="hidden" name="purchasableId" :value="variant.id">
            <button type="submit" class="bg-white block py-2 border border-gray-700 border-b-0 hover:bg-gray-800 text-gray-700 hover:text-white w-full rounded-none my-0 leading-normal" @click.prevent="addToCart(variant.id, 1)">{{ variant.productSize }}
              - {{ variant.price | price }}</button>
          </form>
        </div>
      </div>
      <div class="add-to-cart" v-else>
        <form method="POST" class="mt-0">
          <input type="hidden" name="action" value="commerce/cart/update-cart">
          <input type="hidden" name="qty" value="1">
          <input type="hidden" :name="csrfName" :value="csrfToken">
          <input type="hidden" name="purchasableId" :value="product.defaultVariant.id">
          <button type="submit" class="bg-white block py-2 border border-gray-700 hover:bg-gray-800 text-center text-gray-700 hover:text-white w-full rounded-none mt-0 leading-normal" @click.prevent="addToCart(product.defaultVariant.id, 1)">Add to
            cart</button>
        </form>
      </div> -->
    </div>
  </a>
</article>
</template>

<script>
export default {
  name: 'product',
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      csrfName: window.csrfTokenName,
      csrfToken: window.csrfTokenValue,
      messaging: window.messaging,
    }
  },
  filters: {
    price(number) {
      return "$" + parseFloat(number).toFixed(2);
    }
  },
  methods: {
    openVariants(id) {
      document.getElementById(id).classList.toggle('open');
    },
    addToCart(id, qty) {
      this.$emit('add-to-cart', id, qty);
    }
  }
}
</script>
